package com.findyourbuddies.website.utils

import com.findyourbuddies.website.config.BuildConfig

object EnvironmentUtils {
    fun getEnvironment(): Environment =
        if (BuildConfig.IS_PRODUCTION) Environment.PROD
        else Environment.DEV
}

enum class Environment {
    DEV,
    PROD,
}
